import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import config from "./../firebase.config";
import Buefy from "buefy";

import "./registerServiceWorker";
import "buefy/dist/buefy.css";
import "./main.scss";

import i18n from "./i18n/index";

Vue.config.productionTip = false;
Vue.use(Buefy, {
  defaultIconPack: "fas",
  defaultContainerElement: "#content",
});

let app;
firebase.initializeApp(config);
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      i18n,
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  }
});
